"use strict";

/**
 * Виджет работает "прокси" между тегом input и слайдером
 * Такое использование позволяет, например, отправлять формы, содержащие input,
 * без дополнительного кода - в input всегда находится текущее значение слайдера
 *
 * кроме того, виджет скрывает конкретную реализацию слайдера, самостоятельно создаёт вёрстку.
 */
$.widget("fotobook.rangeslider", {
    sliderWrap: null,
    slider: null,
    sliderWidget: null,
    options: {
        "buttons" : true,
        "step" : 1,
        "min" : 0,
        "max" : 100,
        "create" : $.noop,
        "slide" : $.noop,
        "start" : $.noop,
        "stop" : $.noop,
        "change" : $.noop,
    },
    _create: function(){
        this._super();
        this.element.hide();
        this.createSlider();
        this._on(true, this.sliderWrap.find(".input-range-slider-slide"), {
            "mousedown" : this.slidingButtonStart,
            "mouseup" : this.slidingButtonEnd,
            "mouseleave" : this.slidingButtonEnd,
        });
    },
    _destroy: function(){
        this._super();
        this.slider.remove();
    },
    _setOptionDisabled: function(value){
        this._super();
        this.sliderWrap.toggleClass("ui-state-disabled", !!value);
    },

    _sliderTpl: [
        '<div class="fotobook-range-slider">',
            '<div class="input-range-slider"></div>',
        '</div>',
    ].join(""),
    createSlider: function(){
        var widget = this;
        
        this.sliderWrap = $(this._sliderTpl);

        if (this.options.buttons){
            this.sliderWrap.append($("<div>", {
                "class" : "input-range-slider-slide input-range-slider-plus",
            }));
            this.sliderWrap.prepend($("<div>", {
                "class" : "input-range-slider-slide input-range-slider-minus",
            }));
        }
        this.element.after(this.sliderWrap);
        this.slider = this.sliderWrap.find(".input-range-slider");
        this.slider.slider({
            "value": this.element.val(),
            "min": this.options.min,
            "max": this.options.max,
            "step": this.options.step,
            "create": function(event, ui){
                $(this).find(".ui-slider-handle").attr("title", $(this).slider("value"));
                widget.options.create.call(this, event, ui);
            },
            "slide": function(event, ui){
                $(ui.handle).attr("title", ui.value);
                widget.element.val(ui.value);
                widget.options.slide.call(this, event, ui);
            },
            "start": function(event, ui){
                widget.element.val(ui.value);
                widget.options.start.call(this, event, ui);
            },
            "stop": function(event, ui){
                widget.element.val(ui.value);
                widget.options.stop.call(this, event, ui);
            },
            "change" : function(event, ui){
                widget.element.val(ui.value);
                widget.options.change.call(this, event, ui);
            },
        });
        this.sliderWidget = this.slider.slider("instance");
    },

    value: function(value){
        if (value === undefined){
            return this.element.val();
        }
        this.element.val(value);
        this.sliderWidget.value(value);
        this.sliderWidget.handle.attr("title", value);
        return this;
    },

    timeout: null,
    slideDown: false,
    slidingEvent: false,

    slidingButtonSlide: function(nextDelay){
        var widget = this,
            oldValue = this.sliderWidget.value(),
            step = this.sliderWidget.options.step,
            newValue;

        this.timeout = false;
        newValue = oldValue + (this.slideDown ? -step : step);
        newValue = Math.min(this.sliderWidget.options.max, Math.max(newValue, this.sliderWidget.options.min));

        if (newValue == oldValue) {
            return;
        }

        this.sliderWidget._slide(this.slidingEvent, 0, newValue);
        this.timeout = setTimeout(function(){
            widget.slidingButtonSlide(50);
        }, nextDelay);
    },
    slidingButtonStart: function(event){
        if (this.slidingEvent){
            return;
        }
        this.slidingEvent = event;
        if (this.sliderWidget._start(event, 0) === false) {
            return;
        }
        this.slideDown = $(event.target).hasClass("input-range-slider-minus");
        this.slidingButtonSlide(500);
    },
    slidingButtonEnd: function(event){
        if (!this.slidingEvent){
            return;
        }

        this.slidingEvent = false;
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = false;
        }
        this.sliderWidget._stop(event, 0);
    },
});
